import { createBrowserHistory as newHistory } from 'history';
const history = newHistory();
export default history;
